import { sortBy } from 'remeda';
import {
  COLLECTION_WINDOWS,
  type CollectionCohort,
  type CollectionCohortBucket,
  type CollectionCohorts,
} from 'shared/hooks/use-load-collection-cohorts';

type CohortCell = { share: number; amount: number };

type CohortRow = {
  period: string;
  invoiceCount: number;
  amount: number;
  collectedShare: number;
  unpaidAmount: number;
  cells: ReadonlyArray<CohortCell | null>;
};

export type CohortGrid = {
  windows: ReadonlyArray<number>;
  rows: ReadonlyArray<CohortRow>;
};

const toCell = (bucket: CollectionCohortBucket | null): CohortCell | null => {
  if (bucket === null || bucket.billed === 0) return null;

  return { share: bucket.collected / bucket.billed, amount: bucket.collected };
};

const toRow = (cohort: CollectionCohort): CohortRow => ({
  period: cohort.period,
  invoiceCount: cohort.invoiceCount,
  amount: cohort.amount,
  collectedShare: cohort.amount === 0 ? 0 : cohort.collected / cohort.amount,
  unpaidAmount: cohort.amount - cohort.collected,
  cells: COLLECTION_WINDOWS.map(window => toCell(cohort.buckets[window])),
});

export const toCohortGrid = ({ cohorts }: CollectionCohorts): CohortGrid => ({
  windows: COLLECTION_WINDOWS,
  rows: sortBy(cohorts, [cohort => cohort.period, 'desc']).map(toRow),
});
